module.exports = __webpack_public_path__ + "static/media/route-plus-bubble.c49842d4.svg";